window.bz_local_storage_module = angular.module('bzLocalStorageModule', [])
